import { render, staticRenderFns } from "./ActivationDeliverableContentApprovalProvider.vue?vue&type=template&id=bacf916a&"
import script from "./ActivationDeliverableContentApprovalProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationDeliverableContentApprovalProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports